const SiteInfo = ({
  description = '',
  title = 'Klaviyo',
}) => (
  <>
    <title>{title}</title>
    {description ? <meta name="description" content={description} /> : null}
  </>
);

export default SiteInfo;
